import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

export const _frontmatter = {
  "title": "2-36",
  "description": "Yoga Sutra Chapter 2, Verse 36"
};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h3 {...{
      "id": "-2-36--"
    }}><a parentName="h3" {...{
        "href": "/Chapter-2/2-35/"
      }}>{`<`}</a>{` 2-36 `}{` `}<a parentName="h3" {...{
        "href": "/Chapter-2/2-37/"
      }}>{`>`}</a></h3>
    <h1 {...{
      "id": "satya-pratiṣṭhāyāṃ-kriyā-phala-āśrayatvam"
    }}>{`satya-pratiṣṭhāyāṃ kriyā-phala-āśrayatvam`}</h1>
    <h4 {...{
      "id": "सत्यप्रतिष्थायं-क्रियाफलाश्रयत्वम्"
    }}>{`सत्यप्रतिष्थायं क्रियाफलाश्रयत्वम्`}</h4>
    <h4 {...{
      "id": "when-established-in-truthfulness-the-fruit-corresponds-to-the-activity"
    }}>{`When established in truthfulness, the fruit corresponds to the activity`}</h4>
    <br />
    <p><strong parentName="p">{`satya`}</strong>{` - truthful; honesty; sincere; genuine; actual`}</p>
    <p><strong parentName="p">{`pratiṣṭha`}</strong>{` - established`}</p>
    <p><strong parentName="p">{`kriyā`}</strong>{` - activity; bodily activity; medical treatment or practice`}</p>
    <p><strong parentName="p">{`phala`}</strong>{` - fruit; consequence, effect; result; retribution (good or bad), gain or loss, reward or punishment, advantage or disadvantage`}</p>
    <p><strong parentName="p">{`āśrayatva`}</strong>{` - corresponds`}</p>
    <br />

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      